import { SEO } from '../components/SEO';
import { PageHero } from '../components/PageHero';
import { DarkTexture } from '../components/DarkTexture';

const ZOHO_FORM_URL = 'https://forms.zohopublic.in/infocomp1/form/DPDPAblogContactForm/formperma/iYUj7Uc0iKPqCXfKDGNbC6srRQyAlxKC5QlSmbsnECQ';

const ComplianceAssessment = () => (
  <div className="relative bg-navy min-h-screen overflow-hidden">
    <SEO
      title="DPDPA Compliance Consultation — Get in Touch"
      description="Tell us about your organisation and DPDPA compliance needs — Complyzen's team will review your requirements and get back to you."
      path="/compliance-assessment"
    />
    <PageHero
      testId="assessment-page-hero"
      kicker="Get in Touch · Free Initial Consultation"
      title="Compliance Assessment"
      description="Tell us a little about your organisation and what you need help with — our DPDPA compliance team will review it and reach out."
    />

    <section className="relative py-16 sm:py-20 px-6 sm:px-10 lg:px-16" data-testid="assessment-form-section">
      <DarkTexture orbs={false} />
      <div className="relative max-w-2xl mx-auto bg-paper rounded-2xl p-2 sm:p-3 shadow-[0_24px_60px_-15px_rgba(0,0,0,0.5)]" data-testid="assessment-zoho-form-wrapper">
        <iframe
          data-testid="assessment-zoho-form-iframe"
          title="DPDPA Blog Contact Form"
          src={ZOHO_FORM_URL}
          frameBorder="0"
          style={{ height: '1050px', width: '100%', border: 'none', display: 'block' }}
        />
      </div>
    </section>
  </div>
);

export default ComplianceAssessment;
